export enum LectureStatusType {
  NOT_STARTED = 'not_started',
  ACTIVE = 'active',
  PENDING_APPROVAL = 'pending_approval',
  COMPLETED_SUCCESSFULLY = 'completed',
  NOT_EXECUTED = 'not_executed',
}

export enum LectureStatus {
  INIT = 'INIT',
  START = 'START',
  FINISHED = 'FINISHED',
}

export const getDisplayText = (lectureStatus: LectureStatusType) => {
  switch (lectureStatus) {
    case LectureStatusType.ACTIVE:
      return 'פעיל';
    case LectureStatusType.COMPLETED_SUCCESSFULLY:
      return 'התבצע בהצלחה';
    case LectureStatusType.NOT_EXECUTED:
      return 'בביצוע';
    case LectureStatusType.NOT_STARTED:
      return 'טרם התחיל';
    case LectureStatusType.PENDING_APPROVAL:
      return 'ממתין לאישור';
  }
};

export const getLectureStatusDisplayText = (lectureStatus: LectureStatus) => {
  switch (lectureStatus) {
    case LectureStatus.INIT:
      return 'טרם התחיל';
    case LectureStatus.START:
      return 'התחיל';
    case LectureStatus.FINISHED:
      return 'הסתיים';
  }
};
